import * as featureFlagsActions from './featureFlagsActions';
import featureFlagsReducer from './featureFlagsReducer';
import * as featureFlagsSelectors from './featureFlagsSelectors';
import * as featureFlagsSimplifi from './featureFlagsSimplifi';
import * as featureFlagsTracking from './featureFlagsTracking';
import * as featureFlagsTypes from './featureFlagsTypes';

const { FEATURE_FLAGS_REDUCER_KEY } = featureFlagsTypes;

export {
  FEATURE_FLAGS_REDUCER_KEY,
  featureFlagsActions,
  featureFlagsReducer,
  featureFlagsSelectors,
  featureFlagsSimplifi,
  featureFlagsTracking,
  featureFlagsTypes,
};
